import { getRequestHeaders } from "./headers";
import { handleError, apiFetch, API_BASE } from './api';

export interface CalendarEventEntry {
    pk: string;
    gsi1pk?: string;
    gsi1sk?: string;
    eventId: string;
    title: string;
    description?: string;
    start: string;
    end?: string;
    allDay?: boolean;
    postAnonymously?: boolean;
    rrule?: string;
    duration?: string;
    startRecur?: string;
    endRecur?: string;
    targetGroups: string[];
    createdBy: string;
    createdAt: string;
    updatedBy?: string;
    updatedAt?: string;
}

export interface CreateCalendarEventInput {
    title: string;
    description?: string;
    start: string;
    end?: string;
    allDay?: boolean;
    postAnonymously?: boolean;
    rrule?: string;
    duration?: string;
    startRecur?: string;
    endRecur?: string;
    targetGroups?: string[];
}

export interface UpdateCalendarEventInput {
    title?: string;
    description?: string;
    start?: string;
    end?: string;
    allDay?: boolean;
    postAnonymously?: boolean;
    rrule?: string;
    duration?: string;
    startRecur?: string;
    endRecur?: string;
    targetGroups?: string[];
}

export interface PaginatedCalendarEvents {
    items: CalendarEventEntry[];
    nextToken?: string;
}

export async function fetchCalendarEvents(limit = 100): Promise<PaginatedCalendarEvents> {
    const res = await apiFetch(`${API_BASE}/calendar?limit=${limit}`, { headers: getRequestHeaders() });
    if (!res.ok) await handleError(res);
    return await res.json();
}

export async function createCalendarEvent(input: CreateCalendarEventInput): Promise<CalendarEventEntry> {
    const res = await apiFetch(`${API_BASE}/calendar`, {
        method: 'POST',
        headers: getRequestHeaders('application/json'),
        body: JSON.stringify(input),
    });
    if (!res.ok) await handleError(res);
    return await res.json();
}

export async function updateCalendarEvent(id: string, input: UpdateCalendarEventInput): Promise<CalendarEventEntry> {
    const res = await apiFetch(`${API_BASE}/calendar/${encodeURIComponent(id)}`, {
        method: 'PUT',
        headers: getRequestHeaders('application/json'),
        body: JSON.stringify(input),
    });
    if (!res.ok) await handleError(res);
    return await res.json();
}

export async function deleteCalendarEvent(id: string): Promise<void> {
    const res = await apiFetch(`${API_BASE}/calendar/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        headers: getRequestHeaders(),
    });
    if (!res.ok) await handleError(res);
}
